import axios from 'axios';

export const constantsAxios = axios.create({
  baseURL: `${process.env.REACT_APP_SERVER_URI}/constants`,
});
